// extracted by mini-css-extract-plugin
export var button = "_lg-0";
export var donut = "_lg-1";
export var donutFill = "_lg-3";
export var donutTrack = "_lg-2";